module.exports = __webpack_public_path__ + "img/healthspot_logo.7514739f.svg";